export default __webpack_public_path__ + "static/media/4-small.4a4717ef.png";